import { IConsentResponse } from '../../../entity';
import { IUserRegistrationRepository } from '../../repositories/interfaces/iUserRegistrationRepository';
import { container } from '../../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IGetConsentUseCase {
    execute(apiKey: string, token: string, identityToken: string): Promise<IConsentResponse['data']>;
}

export class GetConsentUseCase implements IGetConsentUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRegistrationRepo(): IUserRegistrationRepository {
        return container.resolve<IUserRegistrationRepository>(DI.REPOSITORIES.IUserRegistrationRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(apiKey: string, token: string, identityToken: string): Promise<IConsentResponse['data']> {
        const response = await this.userRegistrationRepo.getConsent(apiKey, token, identityToken);
        return response.data;
    }
}
